import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
import _slicedToArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { SurveyThemeWrapper } from '@sm/question-ui/theme-respondent';
import { d as declareVisualization, i as isLocalError, b as isRequired, p as providerFactory } from './utils-373d9242.js';
import { pickQuestionTypeDefinition } from '@sm/question-definitions';
import { QuestionRowLayout, CommentBox, SingleTextbox } from '@sm/question-ui/respondent-survey';
export { Q as QuestionListController, S as SingleQuestionController } from './controllers-23d93e17.js';
import './vendor-4368c290.js';

var useShowOkButton = function useShowOkButton(active, touched) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOkButton = _useState2[0],
      setShowOkButton = _useState2[1];

  useEffect(function () {
    if (!active) {
      setShowOkButton(false);
    } else if (touched) {
      setShowOkButton(true);
    }
  }, [active, touched, setShowOkButton]);
  return showOkButton;
}; // Visualization for Question of type CommentBox


var RespondentCommentBoxVisualization = function RespondentCommentBoxVisualization(_ref) {
  var capability = _ref.capability,
      upstreamActions = _ref.upstreamActions,
      question = _ref.question,
      survey = _ref.settings.survey,
      toExternalQuestion = _ref.toExternalQuestion;

  var _a;

  var id = question.id,
      typeId = question.typeId,
      questionNumber = question.questionNumber,
      title = question.title,
      layout = question.layout,
      active = question.active,
      disabled = question.disabled,
      upstreamErrors = question.errors,
      upstreamAnswer = question.answer;
  var definition = pickQuestionTypeDefinition(typeId);
  var padding = (_a = layout === null || layout === void 0 ? void 0 : layout.spacing) !== null && _a !== void 0 ? _a : {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };

  var _useState3 = useState(upstreamErrors.find(isLocalError)),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(upstreamAnswer),
      _useState6 = _slicedToArray(_useState5, 2),
      answer = _useState6[0],
      setAnswer = _useState6[1];

  var showOkButton = useShowOkButton(!!active, answer.touched);
  var surveyModeOptions = survey.isClassic ? {
    variant: 'classic',
    active: active
  } : {
    variant: 'auto-scroll',
    active: !!active,
    showOkButton: showOkButton,
    onSubmit: function onSubmit() {
      var _a;

      var q = definition.validate(question, 'submit', capability);
      var localError = q.errors.find(isLocalError);

      if (localError) {
        setError(localError);
        return;
      }

      (_a = upstreamActions.saveQuestion) === null || _a === void 0 ? void 0 : _a.call(upstreamActions, toExternalQuestion(_objectSpread(_objectSpread({}, q), {}, {
        answer: answer
      })));
    }
  }; // TODO: move QuestionRowLayout to QuestionListController

  return React.createElement(QuestionRowLayout, null, React.createElement(CommentBox, Object.assign({}, surveyModeOptions, {
    title: title,
    padding: padding,
    disabled: disabled,
    survey: survey
  }, {
    questionId: id,
    questionNumber: Number(questionNumber),
    required: isRequired(question),
    error: error === null || error === void 0 ? void 0 : error.message,
    value: answer === null || answer === void 0 ? void 0 : answer.value,
    okLabel: survey.okLabel,
    onUpdate: function onUpdate(value) {
      var _a;

      var newAnswer = {
        touched: true,
        value: value
      };
      setAnswer(newAnswer);
      definition.shortUpdate(_objectSpread(_objectSpread({}, question), {}, {
        active: !!active,
        answer: answer
      }), 'update', capability);
      (_a = upstreamActions.onUpdate) === null || _a === void 0 ? void 0 : _a.call(upstreamActions, newAnswer);
    }
  })));
};

var AnswerCommentBoxVisualization = declareVisualization(['comment_box'], ['respondent-survey'], RespondentCommentBoxVisualization); // Visualization for Question of type SingleTextbox

var RespondentSingleTextboxVisualization = function RespondentSingleTextboxVisualization(_ref2) {
  var capability = _ref2.capability,
      upstreamActions = _ref2.upstreamActions,
      question = _ref2.question,
      survey = _ref2.settings.survey,
      toExternalQuestion = _ref2.toExternalQuestion;

  var _a;

  var id = question.id,
      typeId = question.typeId,
      questionNumber = question.questionNumber,
      title = question.title,
      layout = question.layout,
      active = question.active,
      disabled = question.disabled,
      upstreamErrors = question.errors,
      upstreamAnswer = question.answer;
  var definition = pickQuestionTypeDefinition(typeId);
  var padding = (_a = layout === null || layout === void 0 ? void 0 : layout.spacing) !== null && _a !== void 0 ? _a : {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };

  var _useState7 = useState(upstreamErrors.find(isLocalError)),
      _useState8 = _slicedToArray(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var _useState9 = useState(upstreamAnswer),
      _useState10 = _slicedToArray(_useState9, 2),
      answer = _useState10[0],
      setAnswer = _useState10[1];

  var showOkButton = useShowOkButton(!!active, answer.touched);
  var surveyModeOptions = survey.isClassic ? {
    variant: 'classic',
    active: active
  } : {
    variant: 'auto-scroll',
    active: !!active,
    showOkButton: showOkButton,
    onSubmit: function onSubmit() {
      var _a;

      var q = definition.validate(_objectSpread(_objectSpread({}, question), {}, {
        active: !!active
      }), 'submit', capability);
      var localError = q.errors.find(isLocalError);

      if (localError) {
        setError(localError);
        return;
      }

      (_a = upstreamActions.saveQuestion) === null || _a === void 0 ? void 0 : _a.call(upstreamActions, toExternalQuestion(_objectSpread(_objectSpread({}, q), {}, {
        answer: answer
      })));
    }
  }; // TODO: move QuestionRowLayout to QuestionListController

  return React.createElement(QuestionRowLayout, null, React.createElement(SingleTextbox, Object.assign({}, surveyModeOptions, {
    title: title,
    padding: padding,
    disabled: disabled,
    survey: survey
  }, {
    questionId: id,
    questionNumber: Number(questionNumber),
    required: isRequired(question),
    error: error === null || error === void 0 ? void 0 : error.message,
    value: answer === null || answer === void 0 ? void 0 : answer.value,
    okLabel: survey.okLabel,
    onUpdate: function onUpdate(value) {
      var _a;

      var newAnswer = {
        touched: true,
        value: value
      };
      setAnswer(newAnswer);
      definition.shortUpdate(_objectSpread(_objectSpread({}, question), {}, {
        active: !!active,
        answer: answer
      }), 'update', capability);
      (_a = upstreamActions.onUpdate) === null || _a === void 0 ? void 0 : _a.call(upstreamActions, newAnswer);
    }
  })));
};

var AnswerSingleTextboxVisualization = declareVisualization(['single_textbox'], ['respondent-survey'], RespondentSingleTextboxVisualization);
var visualizationList = [AnswerSingleTextboxVisualization, AnswerCommentBoxVisualization]; // Creates the helper to store the configuration

var ProviderHelper = providerFactory(visualizationList); // Declares the Provider Component itself, with the proper API

var RespondentCapabilityProvider = function RespondentCapabilityProvider(_ref3) {
  var upstreamActions = _ref3.upstreamActions,
      settings = _ref3.settings,
      children = _ref3.children,
      renderProps = _ref3.renderProps;
  // here you can keep capability-specific state, translate actions or make other modifications
  // that are appropriate to your capability-specific behaviour
  return React.createElement(ProviderHelper, {
    value: {
      capability: 'respondent-survey',
      upstreamActions: upstreamActions,
      renderProps: renderProps,
      settings: settings
    }
  }, React.createElement(SurveyThemeWrapper, null, children));
};

export { RespondentCapabilityProvider, visualizationList as RespondentVisualizations };